<div
  class="stitch-list-item with-bar board-row"
  [class.board-row-pinned]="board().pinned"
  [class.selected]="listSelected() && !isDragging()"
  [class.hovered]="contextMenuOpened()"
  [appBoardContextMenu]="board()"
  (appBoardContextMenuOpened)="contextMenuOpened.set($event)"
  (appBoardContextMenuOpenBoard)="open.emit()"
  appDroppable
  [appDroppableDisabled]="!dragEnabled() || board().deleted"
  appDroppableHoverClass="drag-over"
  [appDroppablePredicate]="canDropStitch"
  (appDroppableDrop)="dropStitch($event)"
  appDraggable
  [appDraggableData]="dragData()"
  [appDraggableDisabled]="!dragEnabled()"
  [appDraggablePlaceholder]="dragPlaceholder"
  (appDraggableDraggingChanged)="isDragging.set($event)"
>
  <!-- Prototype BoardLibraryPanel.tsx:84 / BoardLibrary.css: the scene miniature leads the row. -->
  <app-board-thumbnail class="board-row-thumbnail" [elements]="thumbnail().elements" [bounds]="thumbnail().bounds" />
  <div class="stitch-list-item-body">
    <div class="stitch-list-item-body-header">
      <div class="stitch-list-item-body-title">
        <div class="stitch-list-item-body-title-text" [class.blank]="!board().title">
          {{ board().title || 'Untitled board' }}
        </div>
      </div>

      <div class="stitch-list-item-hover-actions" [appClickStopPropagation]="true">
        <stch-quick-action
          icon="sapphire-archive2"
          [active]="board().archived"
          [matTooltip]="board().archived ? Labels.RestoreFromArchive : Labels.Archive"
          (onClick)="archive()"
        />
        <stch-trash-action [deleted]="board().deleted" (onClick)="trash()" />
      </div>
    </div>

    <div class="stitch-list-item-body-item inline">
      Created: {{ board().createdAt | dateFormat: 'relativeDate' }}
      <div class="stitch-list-item-body-item-separator"></div>
      Updated: {{ board().updatedAt | dateFormat: 'relativeDate' }}
    </div>

    <div class="stitch-list-item-body-item truncate">{{ summary() }}</div>

    <div class="bottom-bar">
      <div
        [appStitchInfoPopover]="stitchSummary()"
        [appStitchInfoPopoverContent]="linkedInfoPopoverContent"
        stchPopoverPlacement="bottom"
        (appStitchInfoPopoverOpened)="stitchExpanded.set($event)"
        (appStitchInfoPopoverItemClick)="openStitchItem($event)"
        (appStitchInfoPopoverItemDoubleClick)="openStitchItem($event)"
        [appClickStopPropagation]="true"
        class="bottom-bar-item shrink-0"
        [class.expanded]="stitchExpanded()"
      >
        <app-icon class="bottom-bar-item-icon" name="sapphire-stitch" />
        <span>{{ (stitchCount$ | async) ?? 0 }}</span>
        <app-icon class="bottom-bar-item-icon chevron" name="sapphire-chevron-down" />
      </div>

      @if (locationBadge(); as badge) {
        <app-search-location-badge class="min-w-0 shrink" type="board-folder" [name]="badge.name" />
      }

      <div class="flex-1"></div>

      @if (board().snoozed) {
        <app-icon
          class="bottom-bar-item-icon shrink-0 snoozed"
          name="sapphire-snooze"
          [matTooltip]="board().snoozedUntil ? 'Snoozed until ' + (board().snoozedUntil | dateFormat: 'dateTime') : 'Snoozed'"
        />
      }
      @if (board().followUp) {
        <app-icon
          class="bottom-bar-item-icon shrink-0 followed"
          name="sapphire-follow-up"
          [matTooltip]="board().followUpAt ? 'Follow up on ' + (board().followUpAt | dateFormat: 'dateTime') : 'Follow up'"
        />
      }
      <app-button2
        class="bottom-bar-action shrink-0"
        [class.active]="board().flagged"
        appearance="secondary-ghost"
        size="s"
        [appClickStopPropagation]="true"
        (click)="flag($event)"
      >
        <app-flagged-icon [active]="board().flagged" />
      </app-button2>
      <app-button2
        class="bottom-bar-action shrink-0"
        [class.active]="board().pinned"
        appearance="secondary-ghost"
        size="s"
        [appClickStopPropagation]="true"
        (click)="pin($event)"
      >
        <stch-pinned-icon [active]="board().pinned" />
      </app-button2>
    </div>
  </div>
  <div class="drop-zone"></div>
</div>

<ng-template #linkedInfoPopoverContent let-stitch let-clickStitchItem="clickStitchItem" let-dblClickStitchItem="dblClickStitchItem">
  <app-linked-info-list
    class="container"
    [stitch]="stitch"
    [state]="popoverListState"
    [unlinkParentPairsOnly]="true"
    (clickStitchItem)="clickStitchItem.emit($event)"
    (dblClickStitchItem)="dblClickStitchItem.emit($event)"
  />
</ng-template>

<ng-template #dragPlaceholder>
  <app-board-card [board]="board()" [dragEnabled]="false" [showLocationBadge]="showLocationBadge()" />
</ng-template>
